// Libraries
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// sushiweb
import Shimmer from 'sushiweb/Shimmer';

// styled components
const StyledShimmer = styled(Shimmer)`
  border-radius: 0.6rem;
`;

const ShimmerContainer = styled.div`
  height: 6.6rem;
  width: 100%;
  padding: 2rem 2.4rem;
  box-sizing: border-box;
  border-top: 0.1rem solid rgb(232, 232, 232);
  border-left: ${({ isSlim }) =>
    isSlim ? '0.1rem solid rgb(232, 232, 232)' : 'none'};
  border-right: ${({ isSlim }) =>
    isSlim ? '0.1rem solid rgb(232, 232, 232)' : 'none'};
  border-bottom: none;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  flex-grow: 0;
  :first-child {
    border-radius: ${({ isSlim }) => (isSlim ? '0.8rem 0.8rem 0 0' : 'none')};
  }

  :last-child {
    border-radius: ${({ isSlim }) => (isSlim ? '0 0 0.8rem 0.8rem' : 'none')};
    border-bottom: 0.1rem solid rgb(232, 232, 232);
  }
`;

const ZpaykitFallback = ({ isSlim }) => {
  return (
    <div>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='15rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='20rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='18rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='25rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='30rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
      <ShimmerContainer isSlim={isSlim}>
        <StyledShimmer height='2.5rem' width='28rem' />
        <Shimmer height='2.5rem' width='2.5rem' isCircle />
      </ShimmerContainer>
    </div>
  );
};

export default ZpaykitFallback;

ZpaykitFallback.propTypes = {
  isSlim: PropTypes.bool,
};

ZpaykitFallback.defaultProps = {
  isSlim: false,
};
